import React from 'react'
import { StatusText } from 'ui/elements'
import TrackCardIcon from 'ui/time-tracking/TrackCardIcon'
import * as Displays from 'support/displays'
import { Duration } from 'support/displays'
import { Translation } from '@morningtrain/react-translations'
import SplitRow from 'ui/time-tracking/SplitRow'
import SplitRowContent from 'ui/time-tracking/SplitRowContent'
import DarkText from 'ui/time-tracking/DarkText'
import GrayText from 'ui/time-tracking/GrayText'
import WithSubtitle from '../layouts/WithSubtitle'
import * as UI from 'ui'

function TrackCardRow () {
  return (
    <SplitRow>
      <SplitRowContent className='w-2/5'>
        <WithSubtitle subtitle={(
          <GrayText>
            <Displays.Date name='started_at' dateFormat='DD. MMM YYYY' />
          </GrayText>
        )}
        >
          <DarkText className='capitalize'>
            <Displays.Date name='started_at' dateFormat='dddd' />
          </DarkText>
        </WithSubtitle>
        <TrackCardIcon />
      </SplitRowContent>
      <SplitRowContent className='w-1/3'>
        <WithSubtitle subtitle={(
          <GrayText size='text-sm' className='text-right'>
            <Displays.Enum name='type' enum='toggle_type' />
          </GrayText>
        )}
        >
          <DarkText size='text-sm'>
            <Displays.Enum enum='employment_type_category' name='location' />
          </DarkText>
        </WithSubtitle>
      </SplitRowContent>
      <SplitRowContent className='w-1/3'>
        <WithSubtitle subtitle={(
          <GrayText size='text-sm' className='text-right'>
            <Displays.Integer name='breaks_duration' defaultValue={0} /><span> min</span>
          </GrayText>
      )}
        >
          <DarkText size='text-sm'>
            <Translation name='toggle.break_with_duration' />
          </DarkText>
        </WithSubtitle>
      </SplitRowContent>
      <SplitRowContent className='w-44 justify-end'>
        <WithSubtitle subtitle={(
          <GrayText size='text-sm' className='text-right'>
            <Duration name='duration_as_seconds' fromSeconds />
          </GrayText>
        )}
        >
          <DarkText size='text-sm'>
            <Displays.Time name='started_at' timeFormat='HH:mm' forceUTC />
            <span> - </span>
            <Displays.Time name='stopped_at' timeFormat='HH:mm' forceUTC />
          </DarkText>
        </WithSubtitle>
      </SplitRowContent>
    </SplitRow>
  )
}

export default TrackCardRow
